import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
import { Emoji } from './Emoji';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-forest-800 py-20" data-id="element-74" data-mp="1lcacf2uyo51b">
      <div className="mx-auto max-w-[680px] px-5 sm:px-8" data-id="element-75" data-mp="1gcxrworkba1w">
        <h2 className="inline-flex w-full flex-wrap items-center justify-center gap-2 text-center font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-tight text-cream sm:text-4xl" data-id="element-76" data-mp="1geijc5ikycvj">
          <Emoji symbol="❓" className="text-3xl" data-id="element-77" data-mp="28za4frscu6rm" />
          Lo que más nos preguntan
        </h2>

        <ul className="mt-10 flex flex-col gap-3" data-id="element-78" data-mp="244cy4smgmbif">
          {faqs.map((item, index) => {
          const isOpen = openIndex === index;
          return <li key={item.question} className="overflow-hidden rounded-2xl border border-line bg-pistacho" data-id="element-79" data-mp="so6409l09dux" data-mpi={index}>
                <h3 data-id="element-80" data-mp="phy1pl4l43uf">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-display text-base font-bold text-forest-950 transition-colors duration-150 ease-out hover:text-lime-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-600 sm:text-lg" data-id="element-81" data-mp="phelc8ul1nii">
                    <span data-id="element-82" data-mp="bjhm14oqv305">{item.question}</span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sand" data-id="element-83" data-mp="3sz6g1v03slke">
                      {isOpen ? <MinusIcon className="h-4 w-4 text-lime-700" aria-hidden="true" data-id="element-84" data-mp="1smxturxttc2" /> : <PlusIcon className="h-4 w-4 text-forest-800" aria-hidden="true" data-id="element-85" data-mp="3nz2149eufywa" />}
                    </span>
                  </button>
                </h3>
                <div id={`faq-panel-${index}`} hidden={!isOpen} className="border-t border-line px-5 py-5 text-[15px] leading-relaxed text-forest-800" data-id="element-86" data-mp="1kq9qsgo5zlbc">
                  {item.answer}
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}